// @flow

import { createPrqV3Actions } from './createPrqV3ActionCreator';

const initialState = {
  timeSlotList: [],
  pickupConfig: null,
  fetchingPickupConfig: false,
  fetchedPickupConfig: false,
  pickupData: null,
  fetchingPickupDetails: false,
  fetchedPickupDetails: false,
  postCallFailureMsg: null
};

const createPrqV3Reducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case createPrqV3Actions.NEW_PICKUP:
    case createPrqV3Actions.CREATE_PRQ:
    case createPrqV3Actions.GET_TIME_SLOTS:
    case createPrqV3Actions.GET_PICKUP_CONFIG: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};

export default createPrqV3Reducer;
